import { GETNEW, POSTNEW, EXPORTNEW, EXPORT, uploading, POSTFormData, uploadingImg } from '@/request/http'
// 查询军训视频成绩列表
export const getMTVList = p => POSTNEW('/dataform/military-training/page', p)
// 查询待处理审批列表
export const exportMTVList = p => EXPORT('/dataform/military-training/export', p)
//查询申请详情
export const importMTVList = p => POSTFormData('/dataform/military-training/import', p)

// 升旗新建计划
export const createHoistFlagPlan = p => POSTNEW('/studentgrowthfiles/raiseFlag/insertPlanInfo', p)

// 改变升旗计划状态
export const updateStateHoistFlagPlan = p => POSTNEW('/studentgrowthfiles/raiseFlag/updateApplyStatus', p)

// 升旗分页
export const getHoistFlagTableData = p => POSTNEW('/studentgrowthfiles/raiseFlag/findPage', p)

// 编辑计划
export const editHoistFlagPlan = p => GETNEW('/studentgrowthfiles/raiseFlag/getBasicInfo', p)

// 获取校历
export const getHoistFlagSchoolYearTerm = p => POSTNEW('/studentv2/calendar/findSchoolYearTermTreeNow', p)

// 升旗计划详情分页
export const getHoistFlagDetail = p => POSTNEW('/studentgrowthfiles/raiseFlagApply/pageCollege', p)

// 升旗计划详情统计图
export const getHoistFlagStatisticsInfo = p => POSTNEW('/studentgrowthfiles/raiseFlagApply/getInfoStatis', p)

// 升旗计划导出
export const hoistFlagExportData = p => EXPORTNEW('/studentgrowthfiles/raiseFlagApply/export', p)

// 升旗/宣讲 学院获取正在执行的计划id
export const getHoistingPlanID = p => GETNEW('/studentgrowthfiles/plan/config/getPlaningInfo', p)

// 升旗预约学院获取正在执行的计划信息
export const getHoistingPlanDate = p => POSTNEW('/studentgrowthfiles/raiseFlagApply/facultyDate', p)

// 学院预约升旗提交
export const submitHoistFlag = p => POSTNEW('/studentgrowthfiles/raiseFlagApply/appointmentDate', p)

// 学院预约升旗取消
export const cancelHoistFlag = p => POSTNEW('/studentgrowthfiles/raiseFlagApply/repealAppointMent', p)




// 征兵宣讲分页
export const getArmsPublicizeData = p => POSTNEW('/studentgrowthfiles/conscriptPreach_plan/findPage', p)

// 征兵宣讲创建计划
export const createArmsPublicizePlan = p => POSTNEW('/studentgrowthfiles/conscriptPreach_plan/insertPlanInfo', p)

// 征兵宣讲编辑计划
export const editArmsPublicizePlan = p => GETNEW('/studentgrowthfiles/conscriptPreach_plan/getDetalById', p)

// 征兵宣讲详情分页
export const getArmsPublicizeDetail = p => POSTNEW('/studentgrowthfiles/conscriptPreach_date/page', p)

// 征兵宣讲导出
export const armsPublicizeExportData = p => EXPORTNEW('/studentgrowthfiles/conscriptPreach_faculty/export', p)

// 征兵宣讲详情分页抽屉
export const getArmsPublicizeDetailDrawDData = p => POSTNEW('/studentgrowthfiles/conscriptPreach_apply/getInfoByConsrciptPreachId', p)

// 征兵宣讲详情统计图
export const getArmsPublicizeStatisticsInfo = p => POSTNEW('/studentgrowthfiles/conscriptPreach_date/conscriptPreachStatic', p)

// 征兵宣讲学院获取正在执行的计划信息
export const getArmsPublicizeDate = p => POSTNEW('/studentgrowthfiles/conscriptPreach_apply/facultyDate', p)

// 学院预约宣讲提交
export const submitArmsPublicize = p => POSTNEW('/studentgrowthfiles/conscriptPreach_apply/appointmentDate', p)

// 学院取消预约宣讲
export const cancelArmsPublicize = p => POSTNEW('/studentgrowthfiles/conscriptPreach_apply/repealAppointMent', p)


// WEBPACK FOOTER //
// ./src/api/modules/arms.js